(ns common.schema.entities.decision
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]))

(def schema
  (concat
   (su/date-field :decision/date
                  "Date"
                  {:authorization su/access-user-user
                   :default-field-visibility :in-use})

   (su/text-multiline-field :decision/date-notes
                            "Date notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :decision/participants
                       "Participants"
                       [:entity.type/decision-participant]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/text-simple-field :decision/location
                         "Location"
                         {:authorization su/access-user-user
                          :default-field-visibility :in-use})

   (su/multi-ref-field :decision/deciding-party
                       "Deciding party"
                       [:entity.type/company]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/text-multiline-field :decision/deciding-party-notes
                            "Deciding party notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/option-field :decision/meeting-type
                    "Meeting type"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use})

   (su/text-multiline-field :decision/meeting-type-notes
                            "Meeting type notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/boolean-field :decision/draft?
                     "Draft"
                     {:authorization            su/access-user-user
                      :default-field-visibility :in-use-disabled})

   ;; TODO: do we need attachments?
   common/attachment-schema))
